<script>
 export default {
  methods: {
   isActive(path) {
    return this.$route.path === path;
  },
 },
};
</script>

<template>
<div class="col-xl-3 theiaStickySidebar">
<div class="card">
  <div class="card-body">
    <div class="d-flex flex-column list-group settings-list">
      <router-link to="/general-settings/business-settings" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active">
        <i v-if="isActive('/general-settings/business-settings')" class="ti ti-arrow-badge-right me-2"></i>
        Business Settings</router-link>

      <router-link to="/general-settings/bank-details" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active">
        <i v-if="isActive('/general-settings/bank-details')" class="ti ti-arrow-badge-right me-2"></i>
        Bank Details</router-link>
        
      <router-link to="/general-settings/branch-details" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active">
        <i v-if="isActive('/general-settings/branch-details')" class="ti ti-arrow-badge-right me-2"></i>
        Branch Details</router-link>  

    </div>
  </div>
</div>
</div>
</template>

